'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchVisitorThreads = fetchVisitorThreads;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIVECHAT_API_PREFIX = 'livechat/v1';

function fetchVisitorThreads(_ref) {
  var sessionId = _ref.sessionId,
      portalId = _ref.portalId,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 100 : _ref$limit;

  return _noAuthApiClient2.default.get(LIVECHAT_API_PREFIX + '/thread/visitor', {
    query: { sessionId: sessionId, portalId: portalId, limit: limit }
  }).then(function (response) {
    var threads = response.results || [];

    // This shim is because we now expect threads to contain an assignedAgentId field,
    // but this endpoint doesn't include that field yet.
    return threads.map(function (thread) {
      if (thread.assignedAgentId !== undefined) {
        return thread;
      } else if (thread.responder) {
        thread.assignedAgentId = thread.responder.userId;
      } else {
        thread.assignedAgentId = null;
      }
      return thread;
    });
  });
}